import { withStyles } from "@material-ui/core";
import React from "react";
import DataGrid from "../../../../../dataGrid";
import StatusBar from "../../../../../dataGrid/StatusBar";
import GridHeader from "../../../components/GridHeader";
import GridConfig from "./gridConfig";
import styles from "../../../common/GridStyles";
class IBBillsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
    };
    this.gridConfig = new GridConfig({
      userConfig: this.props.userProfile?.columnPref,
      columnConfig: this.props.configJSON?.gridColumnConfig,
      terminal: this.props.userProfile?.terminal.code,
    });
    this.gridApi = null;
  }

  componentDidMount() {
    this.props.glEventHub.on("IBBillsGrid", this.onSearchTextChanged);
  }

  componentWillUnmount() {
    this.props.glEventHub.off("IBBillsGrid", this.onSearchTextChanged);
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  onCellClicked = (params) => {
    const column = params.colDef?.colId;
    if (column === "totalBills") {
      this.props.showDueBills(params.data);
      return;
    }
    if (column === "batchCheckbox") {
      this.gridApi.refreshCells({ columns: ["batchCheckbox"] });
      this.props.updateSelectedBatches(params.data);
    }
  };

  onSearchTextChanged = (searchText) => {
    this.setState({
      searchText,
    });
  };

  constructStatusBar = (filteredData) => {
    const totalTrailers = filteredData.filter(data=>data.trailerNumber).length
    return [
      {
        label: totalTrailers + " Linehaul Trailers",
        filterCondition: "",
      },
    ];
  };

  render() {
    const { config } = this.gridConfig;
    const { classes, rowData } = this.props;
    return (
      <div className={`${classes.dataGrid} ${classes.gridContent}`}>
        <GridHeader
          title="IB Bills"
          headerId="IBBillsGrid"
          glEventHub={this.props.glEventHub}
        />
        <DataGrid
          defaultColDef={config.defaultColDef}
          rowData={rowData}
          columnDefs={config.columns}
          config={config}
          rowSelection={config.rowSelection}
          rowDeselection={config.rowDeselection}
          deltaRowDataMode={true}
          getRowNodeId={(data) => data.id}
          quickFilterText={this.state.searchText}
          suppressRowClickSelection
          panelLabel={(filteredData) => (
            <StatusBar data={this.constructStatusBar(filteredData)} />
          )}
          rowClassRules={config.rowClassRules}
          onCellClicked={this.onCellClicked}
          onGridReady={this.onGridReady}
        />
      </div>
    );
  }
}

export default withStyles(styles)(IBBillsGrid);
